import { concatClassnames } from "shared/utils/concatClassnames";
import Icon, { IconTypes } from "../icon";
import Spinner from "../spinner";
import { useEffect } from "react";

export enum ButtonTypes {
  LIGHT_BLUE,
  DARK_BLUE,
  YELLOW,
  WHITE,
  TRANSPARENT,
  UNSTYLED,
}

// TODO: add animation on hover
const BUTTON_TYPE_MAPS: Record<string, string> = {
  [ButtonTypes.LIGHT_BLUE]: "gg-bg-dark-blue-100",
  [ButtonTypes.DARK_BLUE]:
    "gg-bg-dark-blue gg-text-white gg-border-none gg-font-bold",
  [ButtonTypes.YELLOW]:
    "gg-bg-yellow gg-text-dark-blue gg-font-bold enabled:hover:gg-bg-yellow-hover",
  [ButtonTypes.WHITE]:
    "gg-bg-white gg-shadow-main gg-text-dark-blue gg-font-bold hover:gg-bg-gray-300",
  [ButtonTypes.TRANSPARENT]: "gg-underline gg-text-white gg-px-0 gg-py-0",
  [ButtonTypes.UNSTYLED]: "",
};

export enum ButtonArrowTypes {
  HIDDEN,
  LEFT,
  RIGHT,
}

const BUTTON_ARROW_MAPS: Record<string, string> = {
  [ButtonArrowTypes.HIDDEN]: "gg-hidden",
  [ButtonArrowTypes.LEFT]: "gg-rotate-180",
  [ButtonArrowTypes.RIGHT]: "",
};

interface ButtonProps {
  children: any;
  className?: string;
  arrowClassName?: string;
  type: ButtonTypes;
  state?: number;
  arrow?: ButtonArrowTypes;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  onMouseEnter?: () => void;
  rest?: any;
}
const Button = ({
  type,
  children,
  className,
  arrowClassName,
  state,
  onClick,
  arrow = ButtonArrowTypes.HIDDEN,
  disabled = false,
  loading = false,
  onMouseEnter,
  ...rest
}: ButtonProps) => {
  useEffect(() => {
    if (loading) {
      disabled = true;
    }
  }, [loading]);

  return (
    <button
      className={concatClassnames(
        "gg-flex gg-items-center gg-py-2.5 gg-px-5 enabled:gg-cursor-pointer gg-relative gg-rounded-sm disabled:gg-opacity-70 gg-transition-all",
        BUTTON_TYPE_MAPS[type],
        className
      )}
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={onMouseEnter}
      {...rest}
    >
      {arrow === ButtonArrowTypes.LEFT ? (
        <Icon
          name={
            type === ButtonTypes.TRANSPARENT
              ? IconTypes.ARROW_WHITE
              : IconTypes.ARROW_RIGHT
          }
          className={concatClassnames(
            "gg-mr-4",
            BUTTON_ARROW_MAPS[arrow],
            arrowClassName
          )}
        />
      ) : (
        <></>
      )}

      {loading ? (
        <>
          Verwerken
          <Spinner className="gg-ml-1 gg-text-black" />
        </>
      ) : (
        children
      )}

      {arrow === ButtonArrowTypes.RIGHT ? (
        <Icon
          name={
            type === ButtonTypes.DARK_BLUE
              ? IconTypes.ARROW_WHITE
              : IconTypes.ARROW_RIGHT
          }
          className={concatClassnames(
            "gg-ml-4",
            BUTTON_ARROW_MAPS[arrow],
            arrowClassName
          )}
        />
      ) : (
        <></>
      )}

      {state ? (
        <span
          className="
            gg-absolute -gg-top-3 -gg-right-3 
            gg-block gg-bg-primary-color 
            gg-text-white gg-px-[7px] gg-py-[1px]
            gg-rounded-full gg-text-sm"
        >
          {state}
        </span>
      ) : (
        <></>
      )}
    </button>
  );
};
export default Button;
